export const translateDocType = (docType) => {
    const docTypeTranslations = {
        FINAL_REPORT: "Rapport Finale d'expertise",
        PRELIMINARY_REPORT: "Rapport préliminaire d’expertise",
        DRIVING_LICENCE: "Permis",
        HONORARY: "Honnoraire",
        INVOICE: "Facture",
        QUOTATION: "Devis",
        CLAIM_REPORTING_DOCUMENT: "Constat",
        //OTHER: "Autres",
        CAR_REGISTRATION: "Carte grise",
        CIN: "CNI",
        VOUCHER: "Quittance",
    };

    return docTypeTranslations[docType] || "Autres";
};
